import React from "react";
import http from "../../util/http";
import { observer } from "mobx-react";
import green from "@material-ui/core/colors/green";
import red from "@material-ui/core/colors/red";
import orange from "@material-ui/core/colors/orange";
import { withStyles } from "@material-ui/core/styles";

import IconButton from "@material-ui/core/IconButton";
import MessageIcon from "@material-ui/icons/Chat";
import ClearIcon from "@material-ui/icons/Clear";
import SaveIcon from "@material-ui/icons/Save";
import DoneAllIcon from "@material-ui/icons/DoneAll";

const styles = {
  actionList: { textAlign: "left", marginBottom: 2, display: "inline-block" },
};
@observer
class ChaseNote extends React.Component {
  state = {
    actionButton: {
      margin: "0 4px",
      fontSize: this.props.isMobile ? 25 : 15,
    },
    messageInputStyle: {
      width: "98%",
      fontSize: this.props.isMobile ? 25 : 15,
      border: "none",
      borderRight: "1px solid rgb(221, 221, 221)",
      background: "transparent",
      padding: 10,
    },
    currentNote: "",
    feedback: {
      display: false,
      message: "",
      style: {
        color: "#000",
        fontSize: this.props.isMobile ? 25 : 15,
      },
    },
    open: false,
    textmask: "",
    textbox: "",
    feedbackMsg: "",
    phones: [],
    defaultPhone: "",
  };
  componentDidMount() {
    const { chaseObj } = this.props;
    // const mobileNumber = chaseObj.Phone.replace(/\D/g, "");
    // const numberWithArea = mobileNumber.lenght === 11 ? mobileNumber : "1" + mobileNumber;
    this.setState({
      currentNote: chaseObj.Message,
      //  textmask: this.formatPhoneNumber(numberWithArea === "1" ? chaseObj.Phone : numberWithArea)
    });
  }

  setFeedback = (feedback) => {
    this.setState({
      feedback,
    });
    setTimeout(() => {
      this.setState({
        feedback: {
          display: false,
          message: "",
          style: {
            color: "#000",
          },
        },
      });
    }, 1500);
  };
  updateMessage = (ev) => {
    ev.preventDefault();
    this.setState({ currentNote: ev.target.value });
  };
  saveChaseNote = async (ev, chaseObj) => {
    ev.preventDefault();
    try {
      /*const chaseSaved = await http.sendCommand("command:chase:save", {
        ...chaseObj,
        Message: this.state.currentNote
      });*/
      const payloadSave = JSON.stringify({
        ...chaseObj,
        Message: this.state.currentNote,
      });
      const chaseSaved = await http.sendHelperCommand(
        "ChaseListSaveHelper.aspx",
        { payload: payloadSave }
      );
      this.props.onSave(chaseSaved);
      this.setFeedback({
        display: true,
        message: "Success Saving Message",
        style: { color: "#388e3c" },
      });
    } catch (err) {
      this.setFeedback({
        display: true,
        message: err.message,
        style: { color: "red" },
      });
      this.props.onFail({ Code: "-1", Message: err.message });
    }
  };
  clearChaseNote = async (ev, chaseObj) => {
    ev.preventDefault();
    try {
      if (chaseObj.cid === "") {
        this.setState({
          currentNote: "",
        });
      } else {
        /*const chaseCleared = await http.sendCommand("command:chase:clear", {
          cid: chaseObj.cid
        });*/
        const chaseCleared = await http.sendHelperCommand(
          "ChaseListClearHelper.aspx",
          { cid: chaseObj.cid }
        );
        this.props.onClear(chaseCleared);
        this.setState({ currentNote: "" });
        this.setFeedback({
          display: true,
          message: "Success Clearing Message",
          style: {
            color: "#388e3c",
          },
        });
        //forcing to behave as a new message in case someone wants to add a new message after cleaning
        chaseObj.cid = "";
      }
    } catch (err) {
      this.setFeedback({
        display: true,
        message: err.message,
        style: {
          color: "red",
        },
      });
      this.props.onFail({ Code: "-1", Message: err.message });
    }
  };
  render() {
    const { chaseObj } = this.props;
    return (
      <div>
        <div
          style={{
            ...styles.actionList,
            width: window.innerWidth < 1430 ? "70%" : "75%",
          }}
        >
          <input
            type="text"
            style={this.state.messageInputStyle}
            onChange={this.updateMessage}
            autoComplete="off"
            value={this.state.currentNote}
            placeholder="Add a note here..."
          />
        </div>
        <div
          style={{
            ...styles.actionList,
            width: window.innerWidth < 1430 ? "30%" : "25%",
            textAlign: "center",
          }}
        >
          {!this.state.feedback.display && (
            <IconButton
              aria-label="More"
              aria-owns={"long-menu"}
              aria-haspopup="true"
              disabled={this.state.currentNote === ""}
              onClick={(ev) => this.clearChaseNote(ev, chaseObj)}
            >
              <ClearIcon
                style={{
                  color: this.state.currentNote === "" ? "#00000036" : red[700],
                }}
              />
            </IconButton>
          )}
          {!this.state.feedback.display && (
            <IconButton
              aria-label="More"
              aria-owns={"long-menu"}
              aria-haspopup="true"
              onClick={(ev) => this.saveChaseNote(ev, chaseObj)}
            >
              <SaveIcon style={{ color: green[700] }} />
            </IconButton>
          )}
          {!this.state.feedback.display && (
            <IconButton
              aria-label="More"
              aria-owns={"long-menu"}
              aria-haspopup="true"
              onClick={() => {
                this.props.toggleDialog();
              }}
            >
              <MessageIcon style={{ color: orange[700] }} />
            </IconButton>
          )}

          {!this.state.feedback.display && (
            <IconButton
              aria-label="More"
              aria-owns={"long-menu"}
              aria-haspopup="true"
            >
              <DoneAllIcon
                style={{ color: !chaseObj.bulkSMS ? "#00000036" : "#06b" }}
              />
            </IconButton>
          )}

          {this.state.feedback.display && (
            <span style={this.state.feedback.style}>
              {this.state.feedback.message}
            </span>
          )}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(ChaseNote);
